import { i18n } from "../../../internationalize/i18n.service"
import type { AuthService } from "../../services/auth.service"

import styleCSS from './signout.component.scss?raw'

export class SignoutButtonComponent extends HTMLElement {
  constructor(private authService: AuthService = window.tbwServices.authService) {
    super()
  }

  connectedCallback() {
    this.attachShadow({ mode: 'open' })
    const style = document.createElement('style')
    style.textContent = styleCSS
    const button = document.createElement('button')
    button.className = 'logout-btn'
    button.textContent = i18n.t('logout')
    button.addEventListener('click', () => this.logout())
    this.shadowRoot!.appendChild(style)
    this.shadowRoot!.appendChild(button)
  }

  logout() {
    this.authService.logout()
    window.location.replace(import.meta.env.VITE_LOGIN_ROUTE)
  }
}
